import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { TransportCompanyTypesModel } from 'src/app/shared/entities/transport-company-type.model';
import { TransportCompanyTypeService } from 'src/app/shared/services/app/transport-company-type.service';


@Component({
    selector: 'app-transport-company-types-add-edit',
    templateUrl: './transport-company-types-add-edit.component.html',
    styleUrls: ['./transport-company-types-add-edit.component.scss']
})
export class TransportCompanyTypesAddEditComponent implements OnInit {

    public uid: string = null;
    public transportCompanyTypesModel: TransportCompanyTypesModel = new TransportCompanyTypesModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private transportCompanyTypesService: TransportCompanyTypeService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }
    }

    onCloseDialog(item: TransportCompanyTypesModel) {
        this.ref.close(item);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.transportCompanyTypesModel.uid],
            id: [this.transportCompanyTypesModel.id],
            name: [this.transportCompanyTypesModel.name, [Validators.required, Validators.maxLength(100)]],
        });
    }

    getItem(): void {
        this.loading = true;
        this.transportCompanyTypesService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.transportCompanyTypesModel.map(response.payload);
                this.form.patchValue(this.transportCompanyTypesModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        this.transportCompanyTypesService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.transportCompanyTypesModel.map(response.payload);
                this.form.patchValue(this.transportCompanyTypesModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Tipul companiei de transport a fost salvat cu success!'
                });
                this.ref.close(this.transportCompanyTypesModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }
}
